module.exports = __webpack_public_path__ + "static/media/7cf3f013-766d-4f16-b9eb-299515316b29.0c661e6c.JPG";